import React from "react";
import Page from "components/common/page/Page.component";
import MapStationsContainer from "containers/gis/stations/MapStations.container";

const MapStationsPage = (() => {
    return (
        <Page title={'Mappa punti di monitoraggio - GIS'}>
            <MapStationsContainer />
        </Page>
    );
})

export default MapStationsPage;
